import React from "react";
import styled from "styled-components";
import { Row, Col, OverlayTrigger, Tooltip  } from "react-bootstrap";
import getConfig from "next/config";

import { FORM_FIELD_KEYS } from "../../../../../constants/forms";
import { getFieldProps } from "../../../../../utils/form-fields";

import TextInput from "../../../controls/TextInput";
import MaskInput from "../../../controls/MaskInput";
import Select from "../../../controls/Select";

const { publicRuntimeConfig } = getConfig();

const StyledImg = styled.img`
  height: 28px;
  width: 28px;
`;

function OwnerInfoBlock({ values = {}, onChange, onMouseEnter, onMouseLeave }) {
  return (
    <Row>
      <Col xs={12}>
        <div className="inputs-block-title">
          <span>Owner Information</span>
        </div>
      </Col>
      <Col xs={12}>
        <Select
          {...getFieldProps(FORM_FIELD_KEYS.ownerTitle)}
          placeholder={getFieldProps(FORM_FIELD_KEYS.ownerTitle)?.placeholder?.replace("*", "")}
          value={values[FORM_FIELD_KEYS.ownerTitle]}
          validated={values.validated}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </Col>
      <Col xs={12}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.ownerFirstName)}
          placeholder={getFieldProps(FORM_FIELD_KEYS.ownerFirstName)?.placeholder?.replace("*", "")}
          value={values[FORM_FIELD_KEYS.ownerFirstName]}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </Col>
      <Col xs={12}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.ownerMiddleName)}
          placeholder={getFieldProps(FORM_FIELD_KEYS.ownerMiddleName)?.placeholder?.replace("*", "")}
          value={values[FORM_FIELD_KEYS.ownerMiddleName]}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </Col>
      <Col xs={12}>
        <TextInput
          {...getFieldProps(FORM_FIELD_KEYS.ownerLastName)}
          placeholder={getFieldProps(FORM_FIELD_KEYS.ownerLastName)?.placeholder?.replace("*", "")}
          value={values[FORM_FIELD_KEYS.ownerLastName]}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </Col>
      <Col xs={12}>
        <Select
          {...getFieldProps(FORM_FIELD_KEYS.ownerSuffixName)}
          placeholder={getFieldProps(FORM_FIELD_KEYS.ownerSuffixName)?.placeholder?.replace("*", "")}
          value={values[FORM_FIELD_KEYS.ownerSuffixName]}
          validated={values.validated}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        />
      </Col>
      <Col xs={12}>
        <MaskInput
          {...getFieldProps(FORM_FIELD_KEYS.ownerSSN)}
          label={(
            <>
              Social Security Number&nbsp;
              <OverlayTrigger
                placement="top"
                delay={{ show: 0, hide: 0 }}
                trigger={["hover", "click"]}
                overlay={(
                  <Tooltip id={`tooltip-${FORM_FIELD_KEYS.ownerSSN}-subhint`} className="subhintTooltipFederal">
                    <span>
                      In order to assign an EIN for an Entity, the IRS requires the Social Security Number of the managing member. 
                      This information is secured with SSL encryption.
                    </span>
                  </Tooltip>
                )}
              >
                <a className="ssn-subhint-title">
                  Why is this needed?
                </a>
              </OverlayTrigger>
            </>
          )}
          placeholder="123-45-6789"
          suffix={(
            <StyledImg src={`${publicRuntimeConfig.basePath}/images/V2/V2-federal/lock-icon.png`} alt="" />
          )}
          value={values[FORM_FIELD_KEYS.ownerSSN]}
          onChange={onChange}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          hideDivider
        />
      </Col>
      <Col xs={12}>
        <div className="inputs-block-divider" />
      </Col>
    </Row>
  );
}

export default OwnerInfoBlock;
